"use client";

import ClearSvg from "../../assets/animations/clear.animated.svg";
import { SvgAnimation, type SvgAnimationProps } from "../svg-animation/svg-animation";

export function ClearAnimation(props: SvgAnimationProps) {
  return <SvgAnimation {...props} svg={ClearSvg} />;
}
